import styles from "./toolbox-all-labels.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { Element } from "PosterEditor/model/poster-types";
import { MapLabel, StaticLabel } from "PosterEditor/model/poster-project";
import { Reorder } from "motion/react";
import { useState } from "react";

interface ToolboxAllLabelsProps {}

export const ToolboxAllLabels = (props: ToolboxAllLabelsProps) => {
  const { project, removeMapLabel } = usePosterProject();
  const { setEditingElement } = useEditorUI();

  const staticLabels = project.staticLabels;

  const elementFromStaticLabel = (label: StaticLabel): Element => {
    return {
      type: "staticLabel",
      id: label.id,
      staticLabel: label,
    };
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Labels</h1>
      </div>
      <div className={styles.content}>
        <MapLabelList />
        <StaticLabelList />
      </div>
    </div>
  );
};

const StaticLabelList = () => {
  const { project, removeStaticLabel } = usePosterProject();
  const { setEditingElement } = useEditorUI();
  const staticLabels = project.staticLabels;

  const elementFromStaticLabel = (label: StaticLabel): Element => {
    return {
      type: "staticLabel",
      id: label.id,
      staticLabel: label,
    };
  };

  return (
    <div className={styles.labelList}>
      <span className={styles.title}>Static Labels</span>
      <div className={styles.listContent}>
        {staticLabels.map((label) => (
          <div className={styles.item}>
            <button
              className={styles.itemButton}
              onClick={() => setEditingElement(elementFromStaticLabel(label))}
            >
              <div className={styles.itemContentLeading}>
                <h3>{label.description}</h3>
                <span className={styles.labelPlaceText}>{label.text}</span>
              </div>
            </button>
            <div className={styles.trailingControls}>
              <DeleteButton onClick={() => removeStaticLabel(label)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const MapLabelList = () => {
  const { project, removeMapLabel } = usePosterProject();
  const { setEditingElement } = useEditorUI();
  const mapLabels = project.mapLabels;

  const elementFromMapLabel = (label: MapLabel): Element => {
    return {
      type: "mapLabel",
      id: label.id,
      mapLabel: label,
    };
  };

  return (
    <div className={styles.labelList}>
      <span className={styles.title}>Map Labels</span>
      <div className={styles.listContent}>
        {mapLabels.map((label) => (
          <div key={label.id} className={styles.item}>
            <button
              className={styles.itemButton}
              onClick={() => setEditingElement(elementFromMapLabel(label))}
            >
              <div className={styles.itemContentLeading}>
                <h3>{label.text}</h3>
                <span className={styles.latLong}>
                  {label.coordinate.lat.toFixed(4)},{" "}
                  {label.coordinate.lng.toFixed(4)}
                </span>
              </div>
            </button>

            <DeleteButton onClick={() => removeMapLabel(label)} />
          </div>
        ))}
      </div>
    </div>
  );
};
